import { db } from "../../../../config/firebase.config";
import create from "zustand";
import { toast } from "react-toastify";
import { config } from "../alerts/index"
// @firebase/firestore
import { getDoc, doc } from "firebase/firestore";

export const useStore = create((set) => ({
    filterValue: 0,
    menuPath: '',
    subMenuPath: '',
    getMenuPath: (payload) => {
      set({ menuPath: payload})
    },
    getSubMenuPath: (payload) => {
      set({ subMenuPath: payload })
    },
    getFilterValue: (payload) => {
        set({ filterValue: payload })
    }
    // storeCoordinates: null,
    // getStoreCoordinates: async () => {
    //     try {
    //         const docRef = doc(db, "settings", "store-locator");
    //         const docSnap = await getDoc(docRef);

    //         if (docSnap.exists()) {
    //             set({ storeCoordinates: docSnap.data() })
    //             return docSnap.data()
    //         } else {
    //             throw new Error("Error getting the co-ordinates")
    //         }
    //     } catch (error) {
    //         console.log(error.message)
    //         toast(error.message, {
    //           ...config,
    //           type: "error",
    //         });
    //     }
    // }
}));